// extracted by mini-css-extract-plugin
export default {"aditem":"AdItem_aditem__ni91u","desc":"AdItem_desc__QU2dS","town":"AdItem_town__+Dir+","phone":"AdItem_phone__BNXlU"};